import { css } from '@fable/theme'
import { FlexBox } from '@fable/components'
import { StreaksShareCardHeader } from './StreaksShareCardHeader'
import { StreakCalendar } from './streak_calendar/StreakCalendar'

export const StreaksShareCard = () => (
  <FlexBox
    className={css`
      width: 352px;
      padding: 16px;
      padding-bottom: 20px;
      min-height: 280px;
    `}
    flexDirection="column"
    justifyContent="center"
  >
    <StreaksShareCardHeader />
    <StreakCalendar />
  </FlexBox>
)
